import React, { useContext } from 'react';
import { Spinner, SpinnerSize, classNamesFunction } from '@fluentui/react';
import { ITenantListProps, ITenantListStyles } from './TenantList.type';
import { tenantListStyles } from './TenantList.styles';
import { IOrganization } from '../SuiteHeader.types';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';
import { CurrentTenant } from './CurrentTenant';
import { OtherTenants } from './OtherTenants';

const getClassNames = classNamesFunction<ITenantListProps, ITenantListStyles>();

export const TenantList: React.FC<ITenantListProps> = props => {
  const classNames = getClassNames(tenantListStyles());
  const { organizations, currentOrgId, hasError, switchTenant } = props;
  const { localizationMap } = useContext(SuiteHeaderContext);
  const { loadingOrganizations, finishLoading, organizationError } = localizationMap;

  const { isLoading, value } = organizations;

  if (hasError) {
    return (
      <div className={classNames.root} role="alert" aria-label={organizationError}>
        <p>{organizationError}</p>
      </div>
    );
  }

  const currentOrg = getCurrentOrg(value, currentOrgId);

  const otherTenants = value.filter(org => org.tenantId != currentOrg?.tenantId);

  return isLoading ? (
    <div role="alert">
      <Spinner size={SpinnerSize.large} ariaLabel={loadingOrganizations} ariaLive={'assertive'} />
    </div>
  ) : (
    <div className={classNames.root}>
      <div role="alert" aria-label={finishLoading} />
      <p className={classNames.introText}>{localizationMap.switchOrgIntroText}</p>
      <CurrentTenant currentOrg={currentOrg} switchTenant={switchTenant} />
      <OtherTenants tenants={otherTenants} switchTenant={switchTenant} />
    </div>
  );
};

const getCurrentOrg = (organizations: IOrganization[], currentOrgId?: string) => {
  return organizations.find(tenant => tenant.tenantId === currentOrgId);
};
